import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';

// ================ Action types ================ //

export const FETCH_PROTOCOL_REQUEST = 'app/ProtocolData/FETCH_PROTOCOL_REQUEST';
export const FETCH_PROTOCOL_SUCCESS = 'app/ProtocolData/FETCH_PROTOCOL_SUCCESS';
export const FETCH_PROTOCOL_ERROR = 'app/ProtocolData/FETCH_PROTOCOL_ERROR';

export const SIGN_PROTOCOL_REQUEST = 'app/ProtocolData/SIGN_PROTOCOL_REQUEST';
export const SIGN_PROTOCOL_SUCCESS = 'app/ProtocolData/SIGN_PROTOCOL_SUCCESS';
export const SIGN_PROTOCOL_ERROR = 'app/ProtocolData/SIGN_PROTOCOL_ERROR';

// ================ Reducer ================ //

const initialState = {
  protocolData: null,
  fetchProtocolInProgress: false,
  fetchProtocolError: null,
  signProtocolInProgress: false,
  signProtocolError: null,
  signProtocolSuccess: false
};

const protocolDataReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_PROTOCOL_REQUEST:
      return {
        ...state,
        fetchProtocolInProgress: true,
        fetchProtocolError: null,
      };
    case FETCH_PROTOCOL_SUCCESS:
      return {
        ...state,
        fetchProtocolInProgress: false,
        protocolData: payload,
      };
    case FETCH_PROTOCOL_ERROR:
      return {
        ...state,
        fetchProtocolInProgress: false,
        fetchProtocolError: payload,
      };

    case SIGN_PROTOCOL_REQUEST:
      return {
        ...state,
        signProtocolInProgress: true,
        signProtocolError: null,
      };
    case SIGN_PROTOCOL_SUCCESS:
      return {
        ...state,
        signProtocolInProgress: false,
        signProtocolSuccess: true
      };
    case SIGN_PROTOCOL_ERROR:
      return {
        ...state,
        signProtocolInProgress: false,
        signProtocolError: payload,
      };

    default:
      return state;
  }
};

export default protocolDataReducer;

// ================ Action creators ================ //

export const fetchProtocolRequest = () => ({ type: FETCH_PROTOCOL_REQUEST });
export const fetchProtocolSuccess = data => ({ type: FETCH_PROTOCOL_SUCCESS, payload: data });
export const fetchProtocolError = error => ({ type: FETCH_PROTOCOL_ERROR, error: true, payload: error });

export const signProtocolRequest = () => ({ type: SIGN_PROTOCOL_REQUEST });
export const signProtocolSuccess = () => ({ type: SIGN_PROTOCOL_SUCCESS });
export const signProtocolError = error => ({ type: SIGN_PROTOCOL_ERROR, error: true, payload: error });

// ================ Thunks ================ //

export const loadData = (params, search) => async (dispatch, _getState, sdk) => {
  dispatch(fetchProtocolRequest());
  const { tx, page, protocolKey } = parse(search);

  try {
    const response = await sdk.newSdk.transactions.getPresignProtocolData({
      transactionId: tx,
      page,
      key: protocolKey,
    });

    dispatch(fetchProtocolSuccess(response));
    return response;
  } catch (e) {
    dispatch(fetchProtocolError(storableError(e)));
    throw e;
  }
};

export const signProtocol = ({ txId, page, file, key }) => async (dispatch, _getState, sdk) => {
  dispatch(signProtocolRequest());

  try {
    const res = await sdk.newSdk.transactions.signProtocol({
      transactionId: txId,
      page,
      signatureFile: file,
      key,
    });

    if (res.error) {
      dispatch(signProtocolError(res.error));
      return res
    }

    dispatch(signProtocolSuccess());
  } catch (e) {
    dispatch(signProtocolError(storableError(e)));
    throw e;
  }
};